import React from 'react'
import { GoogleMap, MarkerF, Marker, useLoadScript } from '@react-google-maps/api'
import { toAbsoluteUrl } from '../../../../../../_metronic/helpers'
import { useLocation } from 'react-router-dom'

// Define libraries as a constant outside the component
const libraries: 'places'[] = ['places']

const center = {
  lat: 37.970833,
  lng: 23.72611,
}

function MapComponent({ zooms = 7, data = [] }: any) {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: 'AIzaSyD32soTrhrAXzmKQp7rH8NsL8NQMhmdqlY',
    libraries, // Use the static libraries array
  })

  const newData = data.map((x, ind) => ({
    id: ind,
    name: x.name,
    ...x.position,
  }))

  const { pathname } = useLocation()

  const containerStyle = {
    width: pathname.includes('collect-orders') ? '800px' : '100%',
    height: pathname.includes('collect-orders') ? '600px' : '700px',
  }

  const getMarkerIcon = () => {
    if (typeof google !== 'undefined' && google.maps) {
      return {
        url: toAbsoluteUrl('/media/location/marker.png'),
        scaledSize: new google.maps.Size(50, 50),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(0, 0),
      }
    }
    return {}
  }

  if (!isLoaded) return <div>Loading...</div>
  if (loadError) return <div>Error loading maps</div>

  return (
    <div className='App'>
      <GoogleMap
        mapContainerStyle={containerStyle}
        mapContainerClassName='map-container'
        center={newData?.[0] || center}
        zoom={zooms}
      >
        {newData.map((location) => (
          <Marker
            key={location.id}
            position={{ lat: location.lat, lng: location.lng }}
            title={location.name}
            // icon={getMarkerIcon()}
            icon="/mapIcon.png"
          />
        ))}
      </GoogleMap>
    </div>
  )
}

export default MapComponent
